import * as React from "react";
import classnames from "classnames";

export const FormGroup: React.SFC<React.HTMLAttributes<HTMLDivElement>> = (props) => {
    const { className, children, ...divProps } = props;
    return (
        <div className={classnames(props.className, 'form-group')} {...divProps}>
            {children}
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/app/components/Forms/FormGroup.tsx